import { actions } from "./action-list";

export function dateDueBreakDownFetched(value) {
  return {
    type: actions.FETCH_BREAK_DOWN_COLLECTION.FETCH_DATE_DUE_BREAK_DOWN_COLLECTION,
    value,
  };
}
